import router from "@/router";

/**
 * Vue Router 를 래핑한 클래스입니다.
 *
 * Router 의 행동을 제어하고 상태값을 저장하기 위한 매니저입니다.
 */
class RouterManager {
    push(data) {
        return router.push(data);
    }

    replace(data) {
        return router.replace(data);
    }

    back() {
        return router.go(-1);
    }
}

const routerManager = new RouterManager();

export default routerManager;